import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import { Tooltip } from "@material-ui/core";

const getWidth = () => {
  if (window.innerWidth < 500) {
    return "90%";
  }
  return "50%";
};

const useStyles = makeStyles({
  root: {
    width: getWidth(),
  },
  media: {
    height: "40vh",
  },
});

function RefferralProgram() {
  const classes = useStyles();

  const reffCode = JSON.parse(localStorage.getItem("user")).invite_friend_code;

  function copy(that) {
    console.log(window.location.origin, "window");
    var inp = document.createElement("input");
    document.body.appendChild(inp);
    inp.value = window.location.origin + "/register/" + that;
    inp.select();
    document.execCommand("copy", false);
    inp.remove();
  }

  return (
    <>
      <section id="content-wrapper" className="content-wrapper calendar-page">
        <div className="container-fluid">
          <p className="small-text-bold page-title">Refferral Program</p>

          <section className="main-content address-page">
            <div className="container">
              <div className="add-items-wrapper mb-m-90 mb-90 mt-3 mt-sm-4">
                <div className="selected-room mt-4 mt-sm-4">
                  <div className="row justify-content-center  pt-40">
                    <Card
                    // className={classes.root}
                    // className="rounded-box"
                    >
                      {/* <CardActionArea> */}
                      <CardMedia
                        className={classes.media}
                        title="Contemplative Reptile"
                      >
                        <div className="refferral-program">
                          <span className="refferral-percentage">5</span>
                          <spam className="refferral-percentage-sign">%</spam>
                          {/* <span className="refferral-percentage-off">OFF</span> */}
                        </div>
                      </CardMedia>
                      <CardContent>
                        <Typography gutterBottom variant="h5" component="h2">
                          Invite friends
                        </Typography>
                        <Typography
                          variant="body2"
                          color="textSecondary"
                          component="p"
                        >
                          Get your 5% off When your friend takes their first
                          move, You'll earn 5% off.
                        </Typography>
                      </CardContent>
                      {/* </CardActionArea> */}
                      <CardActions className="row justify-content-center">
                        <div className="refferral-code mb-4">
                          <spam className="ml-4 mr-4 pl-1" id="refferral_code">
                            {reffCode}
                          </spam>
                          <Tooltip title="Copy" aria-label="copy">
                            <Button
                              size="small"
                              color="primary"
                              className="ml-4 copy-btn"
                              onClick={() => copy(reffCode)}
                            >
                              <FileCopyIcon />
                            </Button>
                          </Tooltip>
                        </div>
                      </CardActions>
                    </Card>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </section>
    </>
  );
}

export default RefferralProgram;

{
  /* <div className="col-12 col-sm-8 mb-4 mb-sm-4">
<div className="rounded-box refferral-program mt-5">
  <div className="row justify-content-center">
    <div
      className="col-12 text-center"
      style={{ marginTop: "10%" }}
    >
      <span className="refferral-percentage">5</span>
      <spam className="refferral-percentage-sign">%</spam>
      <spam className="refferral-percentage-off">
        off
      </spam>
    </div>
  </div>
</div>
</div> */
}
